const productsData = [
  {
    productID: 'quest-genius',
    pathID: 'quest-genius',
    productPrimaryName: 'QuestGenius',
    productDisplayName: 'Quest Genius',
    productIcon: 'https://leyaa.ai/Assets/Dboard-icons/questgenius.svg',
    productPageLink: '/quest-genius',
    pricingPageLink: '/quest-genius/pricing',
    productDesc: 'AI question generator',
  },
  {
    productID: 'code-craft',
    pathID: 'code-craft',
    productPrimaryName: 'CodeCraft',
    productDisplayName: 'Code Craft',
    productIcon: 'https://leyaa.ai/Assets/Dboard-icons/codecraft.svg',
    productPageLink: '/code-craft',
    pricingPageLink: '/code-craft/pricing',
    productDesc: 'AI coding companion',
  },
  {
    productID: 'super-learner',
    pathID: 'super-learner',
    productPrimaryName: 'SuperLearner',
    productDisplayName: 'Super Learner',
    productIcon: 'https://leyaa.ai/Assets/Dboard-icons/superlearner.svg',
    productPageLink: '/super-learner',
    pricingPageLink: '/super-learner/pricing',
    productDesc: 'AI learning companion',
  },
];

export default productsData;
